import api from "../api";

export const patchCheckStatusPin = async () => {
  return api
    .patch({
      endpoint: "/secure-code/check",
      port: process.env.REACT_APP_PORT_VENUE,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
